import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { ListboxModule } from 'primeng/listbox';
import { UserSelectableItem } from '../../models/department';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-master-selctabledetail',
  imports: [
    FormsModule,
    ListboxModule
  ],
  templateUrl: './master-selctabledetail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class MasterSelctabledetailComponent {
  @Input() items: UserSelectableItem[] = [];
  @Input() isReadOnly: boolean = false;

  itemsChange = output<UserSelectableItem[]>();

  selectedItems: UserSelectableItem[] = [];

  ngOnChanges() {
    if (this.items.length > 0) {
      this.selectedItems = this.items.filter(i => i.associated);
    } else {
      this.selectedItems = [];
    }
  }


  onSelectionChange() {
    // 1. Aggiorna lo stato di "associated" su ogni elemento dell'array originale
    this.items.forEach(item => {
      item.associated = this.selectedItems.some(s => s.id === item.id);
    });

    // 2. Emetti l'array aggiornato verso il componente padre
    // Se usi l'approccio moderno Signal-based si chiama come funzione:
    this.itemsChange.emit([...this.items]); 
  }
}
